import { styled } from "@pigment-css/react";
import { FooterValue, MetaLabel, SubLabel } from "@acto/taskpane/field-sales-2/components/primitives/Card";
import { TrendPercent, hasTrend } from "@acto/taskpane/field-sales-2/components/primitives/TrendPercent";

// 2×3 grid so the comparison column stacks label + range caption + value while the
// trend column keeps label + value, both values pinned to the bottom row via `gridRow: 3`.
const TrendFooter = styled("div")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gridTemplateRows: "auto auto auto",
  columnGap: theme.fieldSalesTwo.spacing[16],
  rowGap: theme.fieldSalesTwo.spacing[6],
}));

export interface TrendComparisonProps {
  /** Comparison column label, e.g. "Vorperiode" / "Vorjahr". */
  label: string;
  /** Caption under the label, e.g. the comparison date range. */
  rangeLabel: string;
  /** Formatted comparison total. */
  value: string;
  /** Trend column label, e.g. "Trend". */
  trendLabel: string;
  /** Percent delta vs the comparison total. Null or 0 hides the trend column. */
  trendPercent: number | null;
}

/** Comparison/trend block: prior-period total with its range, and a sentiment-colored delta. */
export function TrendComparison({ label, rangeLabel, value, trendLabel, trendPercent }: TrendComparisonProps) {
  return (
    <TrendFooter>
      <MetaLabel style={{ gridColumn: 1, gridRow: 1 }}>{label}</MetaLabel>
      <SubLabel style={{ gridColumn: 1, gridRow: 2 }}>{rangeLabel}</SubLabel>
      <FooterValue style={{ gridColumn: 1, gridRow: 3 }}>{value}</FooterValue>
      {hasTrend(trendPercent) && (
        <>
          <MetaLabel style={{ gridColumn: 2, gridRow: 1 }}>{trendLabel}</MetaLabel>
          <TrendPercent percent={trendPercent} style={{ gridColumn: 2, gridRow: 3 }} />
        </>
      )}
    </TrendFooter>
  );
}
